"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var order_dto_1 = require("../../src/orders/order.dto");
var defenitions_1 = require("../../src/defenitions");
exports.anOrderResponse = function (overrides) {
    var address = {
        addressLine1: '123',
        addressLine2: '456',
        city: 'city',
        email: 'abc@wix.com',
        fullName: {
            lastName: 'John',
            firstName: 'Smith',
        },
        phone: '123465789',
        street: {
            name: 'abc',
            number: '123',
        },
        subdivision: 'US-NY',
        vatId: {
            number: '123',
            type: '1234',
        },
        zipCode: '123456',
        country: 'US',
        company: 'company',
    };
    var order = {
        id: '1111',
        billingInfo: {
            externalTransactionId: '1',
            paidDate: new Date('05/25/2000').toISOString(),
            paymentMethod: 'paymentMethod',
            address: address,
        },
        buyerInfo: {
            id: 'id',
            email: 'email@wix.com',
            firstName: 'first name',
            identityType: 'identityType',
            lastName: 'last name',
            phone: 'phone',
            type: order_dto_1.BuyerInfoType.MEMBER,
        },
        invoiceInfo: {
            source: '111',
            id: '2222',
        },
        buyerNote: 'some text',
        dateCreated: new Date('05/25/2000').toISOString(),
        currency: 'USD',
        fulfillmentStatus: 'abc',
        archived: false,
        lineItems: [
            {
                customTextFields: [{ title: 'title', value: 'value' }],
                productId: '',
                lineItemType: '',
                mediaItem: {
                    height: 50,
                    mediaType: defenitions_1.MediaItemType.image,
                    url: 'http://static.wixstatic.com/media/289e7e_4d7e6ed33f324a0aa3e1821ee6142781~mv2.jpeg/v1/fill/w_50,h_50,al_c,q_90/file.jpg',
                    width: 50,
                },
                name: 'A great product',
                notes: 'nnnoootttess',
                options: [{ option: 'title', selection: 'value' }],
                price: '5',
                quantity: 1,
                sku: 'sssskkkkuuuu',
                totalPrice: '6',
                weight: '1.42',
            },
        ],
        activities: [],
        number: '123456',
        paymentStatus: 'xyz',
        shippingInfo: {
            deliveryOption: 'abc',
            estimatedDeliveryTime: 'abc',
            pickupDetails: {
                buyerDetails: {
                    email: '',
                    fullName: {
                        firstName: '',
                        lastName: '',
                    },
                    phone: '',
                },
                pickupAddress: {
                    addressLine1: 'addressLine1',
                    city: 'city',
                    subdivision: 'subdivision',
                    zipCode: 'zipCode',
                    country: 'country',
                },
                pickupInstructions: 'abc efg',
            },
            shipmentDetails: {
                address: address,
                trackingInfo: {},
            },
        },
        totals: {
            discount: '0',
            quantity: 1,
            shipping: '2',
            subtotal: '3',
            tax: '0',
            total: '5',
            weight: '1',
        },
        weightUnit: 'kg',
    };
    return { order: __assign({}, order, overrides) };
};
exports.anOrdersResponse = function (overrides) {
    return __assign({ orders: [], totalResults: 0 }, overrides);
};
//# sourceMappingURL=orders.js.map